import { API_PATH } from '../constants';
import axios from "axios";

export  const commonService = {
    sendHttpRequest
}

function sendHttpRequest(URL , data, method) {
    var date = new Date(); var timestamp = date.getTime();

    var params = '';

    if(method === 'GET' && data) {

        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                var val = data[key];
                params += '&'+key+'='+val;
            }
        }
    }

    // Send an HTTP  request
    return axios({
        method: method,
        url: API_PATH+URL+'?t='+timestamp+params,
        data: data,
        async:false
    }).then(function(res){
        console.log("success");
        if(res.data.response === 'failure' || Object.keys(res.data.response).length === 0) {
            return undefined;
        }
        return res;

    }).catch(function(err){
        console.log("error");
        console.log(err);
        return err;
    });

}



// WEBPACK FOOTER //
// ./src/services/common.services.js